module.exports = __webpack_public_path__ + "img/xinhu_template_1.6b472b6d.png";